import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

function usePageVisibility(handler) {
  const location = useLocation()
  const currentPathRef = useRef(location.pathname)
  const handlerRef = useRef(handler)
  
  // Update the handler ref when it changes
  useEffect(() => {
    handlerRef.current = handler
  }, [handler]);

  // Handle visibility change (tab switching, minimizing)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        handlerRef.current()
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [])
  
  
  // Handle React Router navigation
  useEffect(() => {
    return () => {
      
      if (currentPathRef.current && (currentPathRef.current === location.pathname)) {
        handlerRef.current()
      }
      currentPathRef.current = location.pathname;
    };
  }, [location.pathname])
}

export default usePageVisibility;